import React from "react";

export default class extends React.Component {
  render() {
    document.title =
      "Ghostin Reviews - Peter van der Meer - Ik maak LinkedIn gemakkelijk. - Ghostin.nl";

    var headTag = document.getElementsByTagName("head")[0];
    var charsetTag = document.createElement("meta");
    charsetTag.setAttribute("http-equiv", "refresh");
    charsetTag.setAttribute(
      "content",
      "0; URL='https://ghostin.nl/testimonials'",
    );
    headTag.appendChild(charsetTag);

    return (
      <div style={{ margin: "3em" }}>
        Je wordt doorgestuurd naar{" "}
        <a href="https://ghostin.nl/testimonials">ghostin.nl/testimonials</a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/redir_testimonials.js